import React from "react";

const InsuranceMenu = ({ menu }) => {
  let title = "No Title";
  let className = "";

  const renderedMenu = menu.map((item, idx) => {
    className = "btn--base ";
    let menuButtonStyle = {
      color: "white!important",
      backgroundColor: "#010156!important",
      borderColor: "#010156!important",
    };

    if (item.active) {
      className += "btn--success active";
      menuButtonStyle = {
        color: "white!important",
        backgroundColor: "#146c43!important",
        borderColor: "#13653f!important",
      };
    } else {
      className += "btn--primary active";
    }

    if (item.active) {
      title = item.title;
    }

    console.log({ active: item.active, title });

    return (
      <a
        href={item.link}
        className={className}
        key={idx}
        style={menuButtonStyle}
        aria-current="page"
      >
        {item.title}
      </a>
    );
  });

  return (
    <div className="row">
      <div className="col-md-12 mb-3 text-center">
        <div className="row my-4">
          <div className="btn-group">{renderedMenu}</div>
        </div>
      </div>
      <h2 className="col-md-12 text-center mb-2 fs-4">{title}</h2>
    </div>
  );
};

export default InsuranceMenu;
